export const useDesignSystemVar = (
  variable: string | undefined,
): string | undefined => {
  if (!variable) return;
  const styles = getComputedStyle(document.body, null);
  if (!variable.includes("var")) return variable;
  const varValue = variable.substring(
    variable.lastIndexOf("(") + 1,
    variable.lastIndexOf(")"),
  );
  return styles.getPropertyValue(varValue).trim();
};
